/**
 * ★ Fase 91 (Doc 02) — Microcopy obbligatoria accanto a ogni CTA/form:
 * «Nessun obbligo di acquisto; condizioni e disponibilità soggette a verifica».
 * Tema `dark` (landing scure, es. Bali/Lombok) o `light` (Three Garden/Narea).
 */
import React from 'react';
import { ShieldCheck } from 'lucide-react';

export const NO_OBLIGATION_TEXT = {
  it: 'Nessun obbligo di acquisto; condizioni e disponibilità soggette a verifica.',
  es: 'Sin obligación de compra; condiciones y disponibilidad sujetas a verificación.',
  en: 'No obligation to buy; terms and availability subject to verification.',
};

export function NoObligationNote({ lang = 'it', theme = 'dark', className = '', testId = 'no-obligation-note', compact = false, color: colorOverride, iconColor: iconOverride }) {
  const text = NO_OBLIGATION_TEXT[lang] || NO_OBLIGATION_TEXT.it;
  const color = colorOverride || (theme === 'dark' ? '#CFC6B2' : '#5A6B67');
  const iconColor = iconOverride || (theme === 'dark' ? '#D6B25E' : '#5F6B49');
  return (
    <p
      className={`flex items-start justify-center gap-2 font-sans leading-snug ${compact ? 'text-[11px]' : 'text-xs sm:text-[13px]'} ${className}`}
      style={{ color }}
      data-testid={testId}
    >
      <ShieldCheck className={`${compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} shrink-0 mt-[1px]`} style={{ color: iconColor }} aria-hidden="true" />
      <span>{text}</span>
    </p>
  );
}
